var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25C9 1.00781 10.0078 0 11.25 0H18.75C19.9922 0 21 1.00781 21 2.25V24H17.25V20.25C17.25 19.0078 16.2422 18 15 18C13.7578 18 12.75 19.0078 12.75 20.25V24H9V2.25ZM2.25 4.5H7.5V24H2.25C1.00781 24 0 22.9922 0 21.75V15H3.75C4.1625 15 4.5 14.6625 4.5 14.25C4.5 13.8375 4.1625 13.5 3.75 13.5H0V10.5H3.75C4.1625 10.5 4.5 10.1625 4.5 9.75C4.5 9.3375 4.1625 9 3.75 9H0V6.75C0 5.50781 1.00781 4.5 2.25 4.5ZM27.75 4.5C28.9922 4.5 30 5.50781 30 6.75V9H26.25C25.8375 9 25.5 9.3375 25.5 9.75C25.5 10.1625 25.8375 10.5 26.25 10.5H30V13.5H26.25C25.8375 13.5 25.5 13.8375 25.5 14.25C25.5 14.6625 25.8375 15 26.25 15H30V21.75C30 22.9922 28.9922 24 27.75 24H22.5V4.5H27.75ZM14.625 3C14.2125 3 13.875 3.3375 13.875 3.75V4.875H12.75C12.3375 4.875 12 5.2125 12 5.625V6.375C12 6.7875 12.3375 7.125 12.75 7.125H13.875V8.25C13.875 8.6625 14.2125 9 14.625 9H15.375C15.7875 9 16.125 8.6625 16.125 8.25V7.125H17.25C17.6625 7.125 18 6.7875 18 6.375V5.625C18 5.2125 17.6625 4.875 17.25 4.875H16.125V3.75C16.125 3.3375 15.7875 3 15.375 3H14.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.2207196b76e780ac9a41397ae8bf9513.svg";
export { ForwardRef as ReactComponent };